import {SearchFilter} from "./SearchFilter";

export class SearchOptions{
  filters?: SearchFilter[];
  term?: string | undefined | null;
  order_by?: string;
  order?: string;
  extend?: string[]
}
